module.exports = __WEBPACK_EXTERNAL_MODULE__redux_saga_core__;